var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('b-modal', {
    attrs: {
      "hide-header": "",
      "hide-footer": "",
      "centered": "",
      "no-close-on-backdrop": "",
      "size": "lg"
    },
    on: {
      "hide": _vm.handleClose
    },
    model: {
      value: _vm.showDialog,
      callback: function ($$v) {
        _vm.showDialog = $$v;
      },
      expression: "showDialog"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "warning",
      "show": _vm.alert.show && _vm.confirmStep === 'form'
    }
  }, [_vm._v(" " + _vm._s(_vm.alert.message) + " ")]), _c('b-row', {
    staticClass: "mb-4",
    attrs: {
      "align-h": "between"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/icon_logo_violet.svg"),
      "alt": ""
    }
  })]), _c('b-col', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "tw-text-eclipse",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "x-circle",
      "font-scale": "1.5"
    }
  })], 1)])], 1), _c('b-row', {
    staticClass: "mt-4 pr-4"
  }, [_c('b-col', {
    staticClass: "text-primary",
    attrs: {
      "cols": "3"
    }
  }, [_vm._v(" New Reassignment ")]), _c('b-col', [_c('span', {
    staticClass: "text-small text-muted"
  }, [_vm._v("Patient")]), _c('br'), _c('span', [_vm._v(_vm._s(_vm.rowData.firstname) + " " + _vm._s(_vm.rowData.lastname))]), _c('div', {
    staticClass: "text-small text-muted mt-3"
  }, [_vm._v("State")]), _c('div', [_vm._v(_vm._s(_vm.rowData.state))]), _c('div', {
    staticClass: "text-small text-muted mt-3"
  }, [_vm._v("Reassignment type")]), _c('b-form-select', {
    staticClass: "mt-1",
    attrs: {
      "options": _vm.reassignmentTypeOptions
    },
    model: {
      value: _vm.reassignmentType,
      callback: function ($$v) {
        _vm.reassignmentType = $$v;
      },
      expression: "reassignmentType"
    }
  }), _vm.isTemporary ? [_c('div', {
    staticClass: "text-small text-muted mt-3"
  }, [_vm._v("Start date")]), _c('div', [_vm._v("Now (" + _vm._s(_vm.startDateLabel) + ")")]), _c('div', {
    staticClass: "text-small text-muted mt-3 mb-1"
  }, [_vm._v("Reassign until")]), _c('BaseDateTimePicker', {
    attrs: {
      "trigger": "",
      "block": "",
      "calendars": 1,
      "min-date": _vm.today,
      "quick-select-options": _vm.untilPresets,
      "trigger-label": _vm.untilLabel,
      "value": _vm.untilRange
    },
    on: {
      "input": _vm.onUntilInput
    },
    scopedSlots: _vm._u([{
      key: "trigger",
      fn: function ({
        toggle,
        label
      }) {
        return [_c('b-button', {
          staticClass: "tw-flex tw-items-center tw-text-left",
          attrs: {
            "variant": "outline-secondary",
            "size": "sm",
            "block": ""
          },
          on: {
            "click": toggle
          }
        }, [_c('b-icon', {
          staticClass: "tw-mr-2",
          attrs: {
            "icon": "calendar3"
          }
        }), _vm._v(" " + _vm._s(label) + " ")], 1)];
      }
    }], null, false, 1008255529)
  })] : _vm._e()], 2), _c('b-col', [_c('span', {
    staticClass: "text-primary text-small"
  }, [_vm._v("Reassign To")]), _c('b-row', {
    staticClass: "mb-3",
    attrs: {
      "h-align": "between"
    }
  }, [_c('b-col', [_c('span', {
    staticClass: "text-muted text-small"
  }, [_vm._v("Doctor")])])], 1), _c('div', {
    staticStyle: {
      "max-height": "450px",
      "overflow-y": "auto",
      "overflow-x": "hidden"
    }
  }, _vm._l(_vm.doctorsInState, function (doctor, index) {
    return _c('b-row', {
      key: index,
      attrs: {
        "h-align": "between"
      }
    }, [_c('b-col', [_c('b-form-checkbox', {
      attrs: {
        "value": doctor.id,
        "unchecked-value": null,
        "name": "selected-doctor"
      },
      model: {
        value: _vm.selectedDoctor,
        callback: function ($$v) {
          _vm.selectedDoctor = $$v;
        },
        expression: "selectedDoctor"
      }
    }, [_vm._v(" Dr " + _vm._s(doctor.firstname) + " " + _vm._s(doctor.lastname) + " "), _c('div', {
      staticClass: "text-muted text-small"
    }, [_vm._v(_vm._s(_vm.getStates(doctor)))])])], 1), _c('b-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('hr', {
      staticStyle: {
        "margin-top": "8px",
        "margin-bottom": "8px"
      }
    })])], 1);
  }), 1)], 1)], 1), _c('b-row', {
    staticClass: "mt-4"
  }, [_c('b-col', {
    attrs: {
      "offset": "3"
    }
  }, [_c('b-row', [_c('b-col', [_c('b-button', {
    attrs: {
      "variant": "outline-dark",
      "pill": "",
      "block": "",
      "disabled": _vm.isProcessing
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v(" Back ")])], 1), _c('b-col', [_c('b-button', {
    attrs: {
      "variant": "secondary",
      "pill": "",
      "block": "",
      "disabled": _vm.isProcessing || !_vm.selectedDoctor
    },
    on: {
      "click": _vm.openConfirmStep
    }
  }, [_vm.isProcessing ? _c('b-spinner', {
    attrs: {
      "small": ""
    }
  }) : _c('span', [_vm._v(" Confirm ")])], 1)], 1)], 1)], 1)], 1)], 1), _c('b-modal', {
    attrs: {
      "hide-header": "",
      "hide-footer": "",
      "centered": "",
      "no-close-on-backdrop": "",
      "size": "md"
    },
    model: {
      value: _vm.showConfirmModal,
      callback: function ($$v) {
        _vm.showConfirmModal = $$v;
      },
      expression: "showConfirmModal"
    }
  }, [_c('div', {
    staticClass: "p-2"
  }, [_vm.confirmStep === 'confirm' ? [_c('div', {
    staticClass: "tw-mb-3 tw-flex tw-items-start"
  }, [_c('div', {
    staticClass: "tw-mr-3 tw-flex tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-secondary/10 tw-text-secondary",
    staticStyle: {
      "width": "40px",
      "height": "40px"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "check2-square",
      "font-scale": "1.2"
    }
  })], 1), _c('div', [_c('p', {
    staticClass: "tw-font-semibold"
  }, [_vm._v(" Confirm reassignment ")]), _c('p', {
    staticClass: "text-muted text-small"
  }, [_vm._v(" Review the details before reassigning " + _vm._s(_vm.rowData.firstname) + " " + _vm._s(_vm.rowData.lastname) + " ")])])]), _c('b-alert', {
    staticClass: "mb-3",
    attrs: {
      "variant": "warning",
      "show": _vm.alert.show
    }
  }, [_vm._v(" " + _vm._s(_vm.alert.message) + " ")]), _c('div', {
    staticClass: "tw-bg-light tw-mb-4 tw-rounded tw-p-3"
  }, [_c('div', {
    staticClass: "tw-flex tw-justify-between tw-py-2",
    staticStyle: {
      "border-bottom": "1px solid #e5e5e5"
    }
  }, [_c('span', {
    staticClass: "text-muted text-small"
  }, [_vm._v("Doctor")]), _c('span', [_vm._v(_vm._s(_vm.selectedDoctorLabel))])]), _c('div', {
    staticClass: "tw-flex tw-justify-between tw-py-2",
    style: _vm.isTemporary ? 'border-bottom: 1px solid #e5e5e5;' : ''
  }, [_c('span', {
    staticClass: "text-muted text-small"
  }, [_vm._v("Type")]), _c('span', [_vm._v(_vm._s(_vm.reassignmentTypeLabel))])]), _vm.isTemporary ? [_c('div', {
    staticClass: "tw-flex tw-justify-between tw-py-2",
    staticStyle: {
      "border-bottom": "1px solid #e5e5e5"
    }
  }, [_c('span', {
    staticClass: "text-muted text-small"
  }, [_vm._v("Start date")]), _c('span', [_vm._v("Now (" + _vm._s(_vm.startDateLabel) + ")")])]), _c('div', {
    staticClass: "tw-flex tw-justify-between tw-py-2"
  }, [_c('span', {
    staticClass: "text-muted text-small"
  }, [_vm._v("Reassign until")]), _c('span', [_vm._v(_vm._s(_vm.untilLabel))])])] : _vm._e()], 2), _c('b-row', [_c('b-col', [_c('b-button', {
    attrs: {
      "variant": "outline-dark",
      "pill": "",
      "block": "",
      "disabled": _vm.isProcessing
    },
    on: {
      "click": function ($event) {
        _vm.confirmStep = 'form';
      }
    }
  }, [_vm._v(" Cancel ")])], 1), _c('b-col', [_c('b-button', {
    attrs: {
      "variant": "secondary",
      "pill": "",
      "block": "",
      "disabled": _vm.isProcessing
    },
    on: {
      "click": _vm.submitReassignment
    }
  }, [_vm.isProcessing ? _c('b-spinner', {
    attrs: {
      "small": ""
    }
  }) : _c('span', [_vm._v(" Confirm reassignment ")])], 1)], 1)], 1)] : _vm.confirmStep === 'success' ? [_c('div', {
    staticClass: "tw-mb-3 tw-flex tw-items-start"
  }, [_c('div', {
    staticClass: "tw-mr-3 tw-flex tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-secondary/10 tw-text-secondary",
    staticStyle: {
      "width": "40px",
      "height": "40px"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "check-lg",
      "font-scale": "1.2"
    }
  })], 1), _c('div', [_c('div', {
    staticClass: "tw-font-semibold"
  }, [_vm._v(" Reassignment confirmed ")]), _c('div', {
    staticClass: "text-muted text-small"
  }, [_vm._v(" " + _vm._s(_vm.reassignmentTypeLabel) + " reassignment created ")])])]), _c('p', {
    staticClass: "mb-4"
  }, [_vm._v(" " + _vm._s(_vm.successMessage) + " ")]), _c('b-button', {
    attrs: {
      "variant": "secondary",
      "pill": "",
      "block": ""
    },
    on: {
      "click": _vm.finishSuccess
    }
  }, [_vm._v(" Done ")])] : _vm._e()], 2)]), _c('b-modal', {
    attrs: {
      "hide-header": "",
      "hide-footer": "",
      "centered": "",
      "no-close-on-backdrop": "",
      "size": "md"
    },
    model: {
      value: _vm.showUnsavedDialog,
      callback: function ($$v) {
        _vm.showUnsavedDialog = $$v;
      },
      expression: "showUnsavedDialog"
    }
  }, [_c('div', {
    staticClass: "tw-mb-3 tw-flex tw-items-start"
  }, [_c('div', {
    staticClass: "tw-mr-3 tw-flex tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-secondary/10 tw-text-secondary",
    staticStyle: {
      "width": "40px",
      "height": "40px"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "check-lg",
      "font-scale": "1.2"
    }
  })], 1), _c('div', [_c('p', {
    staticClass: "tw-font-semibold"
  }, [_vm._v(" Discard this reassignment? ")]), _c('p', {
    staticClass: "text-muted text-small"
  }, [_vm._v(" Your unsaved changes will be lost ")])])]), _c('b-row', [_c('b-col', [_c('b-button', {
    attrs: {
      "variant": "outline-dark",
      "pill": "",
      "block": "",
      "disabled": _vm.isProcessing
    },
    on: {
      "click": function ($event) {
        _vm.showUnsavedDialog = false;
      }
    }
  }, [_vm._v(" Keep editing ")])], 1), _c('b-col', [_c('b-button', {
    attrs: {
      "variant": "secondary",
      "pill": "",
      "block": "",
      "disabled": _vm.isProcessing
    },
    on: {
      "click": _vm.confirmClose
    }
  }, [_vm._v(" Discard changes ")])], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };